export const inclickSources = {
    DEAL_IMAGE: 'Deal - Image',
    DEAL_TITLE: 'Deal - Title',
    DEAL_PRICE: 'Deal - Price',
    DEAL_COMMENTS: 'Deal - Comments',
    SIDEBAR_DEAL_TITLE: 'Sidebar Deal - Title',
};
